import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExpand = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0284 19.3678L27.9676 26.7406C28.1624 27.4812 27.4865 28.1569 26.7459 27.962L19.3747 26.0216C18.81 25.8729 18.9146 25.0421 19.4985 25.038L23.0333 25.0136C23.2061 25.0125 23.3737 24.9894 23.5335 24.947L19.2431 20.6571C18.8526 20.2666 18.8526 19.6334 19.2431 19.2429C19.6336 18.8523 20.2668 18.8523 20.6573 19.2428L24.9506 23.5358C24.9943 23.3738 25.0182 23.2036 25.0195 23.0281L25.0449 19.4914C25.0491 18.9076 25.8799 18.8032 26.0284 19.3678Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.97306 19.3678L4.03391 26.7406C3.83912 27.4812 4.51502 28.1569 5.25559 27.962L12.6268 26.0216C13.1915 25.8729 13.0869 25.0421 12.503 25.038L8.96817 25.0136C8.79537 25.0125 8.62777 24.9894 8.46803 24.947L12.7584 20.6571C13.1489 20.2666 13.1489 19.6334 12.7584 19.2429C12.3679 18.8523 11.7347 18.8523 11.3442 19.2428L7.05084 23.5358C7.00715 23.3738 6.98329 23.2036 6.98203 23.0281L6.9566 19.4914C6.95241 18.9076 6.12158 18.8032 5.97306 19.3678Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0284 12.6281L27.9676 5.25538C28.1624 4.51477 27.4865 3.83902 26.7459 4.03397L19.3747 5.97438C18.81 6.12303 18.9146 6.95387 19.4985 6.9579L23.0333 6.9823C23.2061 6.98349 23.3737 7.00658 23.5335 7.04893L19.2431 11.3389C18.8526 11.7294 18.8526 12.3626 19.2431 12.7531C19.6336 13.1436 20.2668 13.1436 20.6573 12.7531L24.9506 8.46017C24.9943 8.62217 25.0182 8.79233 25.0195 8.96787L25.0449 12.5045C25.0491 13.0884 25.8799 13.1928 26.0284 12.6281Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.97306 12.6281L4.03391 5.25538C3.83912 4.51477 4.51502 3.83902 5.25559 4.03397L12.6268 5.97438C13.1915 6.12303 13.0869 6.95387 12.503 6.9579L8.96817 6.9823C8.79537 6.98349 8.62777 7.00658 8.46803 7.04893L12.7584 11.3389C13.1489 11.7294 13.1489 12.3626 12.7584 12.7531C12.3679 13.1436 11.7347 13.1436 11.3442 12.7531L7.05084 8.46017C7.00715 8.62217 6.98329 8.79233 6.98203 8.96787L6.9566 12.5045C6.95241 13.0884 6.12158 13.1928 5.97306 12.6281Z",
			fill: "white"
		})
	]
});
export default SvgIconExpand;
